import { BOD_RULES } from 'utils/validations';
import * as Yup from 'yup';
import { CONSTS } from './consts';

export const validationMessages = {
  REQUIRED: 'Vui lòng nhập',
  INVALID: 'Không hợp lệ',
};

export const inputDateSchema = Yup.object().shape({
  [CONSTS.DAY.KEY]: Yup.number()
    .typeError(validationMessages.INVALID)
    .required(validationMessages.REQUIRED)
    .min(1, validationMessages.INVALID)
    .max(31, validationMessages.INVALID),
  [CONSTS.MONTH.KEY]: Yup.number()
    .typeError(validationMessages.INVALID)
    .required(validationMessages.REQUIRED)
    .min(1, validationMessages.INVALID)
    .max(12, validationMessages.INVALID),
  [CONSTS.YEAR.KEY]: Yup.number()
    .typeError(validationMessages.INVALID)
    .required(validationMessages.REQUIRED)
    .min(
      new Date().getFullYear() - (BOD_RULES.MAX_AGE + 1),
      validationMessages.INVALID,
    )
    .max(
      new Date().getFullYear() - BOD_RULES.MIN_AGE,
      validationMessages.INVALID,
    ),
});
